import api from "@/services/api.service";
import { required } from "vuelidate/lib/validators";

export default {
  name: "add",
  components: {},
  props: {},
  data() {
    return {
      caption: "Add Marketing",
      marketing_form: true,
      showField: true,
      headers: [],
      formField: { title: "", campaign_id: "", event_date: "" },
      submitStatus: null,
      campaigns:[],
      admin:[],
      permission_add: false,
      superAdmin: false
    };
  },
  computed: {},
  validations: {
    formField: {
      title: {
        required
      },
      campaign_id: {
        required
      },
      // admin_id: {
      //   required
      // },
      event_date: {
        required
      }
    }
  },
  async created() {
    let response = await api.post("users/user-permissions");
        const permissions = [];
        response.data[0].permission.forEach( function(element) {                
          permissions.push(element.action)
        }.bind(this));
        if(permissions.includes("add_event") == true ){
            this.getCampaign();
            this.getAdmin();
            this.permission_add = permissions.includes("add_event");
          }else if(response.data[0].role == 'super_admin'){
            this.getCampaign();
            this.getAdmin();   
            this.superAdmin = true;
          }else if(permissions.includes("list_event") == true || permissions.includes("add_event") == true){
              this.makeToast("Permission denied","Alert","warning",6000);
              this.$router.push({name: 'List Event'});
          }else{
              this.makeToast("Permission denied","Alert","warning",6000);
              this.$router.push({name: 'Admin Dashboard'});
          }
  },
  mounted() {},
  methods: {
    makeToast(
      message = "",
      title = "Alert",
      variant = "warning",
      time = "3000"
      ) {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: time
      });
    },
    async getCampaign() {
      let response = await api.post("campaign/list",);
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );              
      if (response.status == "success") {
        if (response.data != "") {
          response.data.data.forEach( function(element) {                      
            this.campaigns.push({value:element.id,text:element.name});
          }.bind(this));                   
        }
      }
    },async getAdmin() {      
      let response = await api.post("users/get-user-List",{type:'admin'});
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
      // if (response.status == "success") {
      //   if (response.data != "") {
      //     response.data.forEach( function(element) {
      //       this.admin.push({value:element.id,text:element.first_name +' '+element.last_name});
      //     }.bind(this));

      //   }
      // }
      this.isBusy = false;
    },async save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {        

        let response = await api.post("admin/marketing-event/add", this.formField);
        if (!response)
          this.makeToast("Something went to wrong please try again", "Alert", "danger",6000);

        if (response.status == "success") {          
          this.makeToast(response.message, "Success", "success");
          this.$router.push({ name: "List Event" });
        } else {
          for (var error in response.errors)
            this.makeToast(response.errors[error], "Alert", "danger", 6000);
        }        
      }
    }
  }
};
